import config from "../config"
const baseUrl = config.base_url + "z_farm_work_lib/"
const baseUrl2 = config.base_url + "v2/z_farm_work_lib/"
export default {
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    detailV2: {
        url: baseUrl2 + "detail",
        type: "get",
    },
    saveV2: {
        url: baseUrl2 + "save",
        type: "post",
    },
    problemZoneLevelTwoOptions: {
        url: baseUrl2 + "problemZoneLevelTwoOptions",
        type: "get",
    },
}

